/**
 * @desc 修改研发物品
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  body: defs.basics.ResearchItemUpdateRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/product/sku/updateResearchItem`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
